import "babel-polyfill";
import iziToast from "izitoast";
import { removeCookie } from "tiny-cookie";
import Vue from "vue";

import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import vuetifyMask from "./plugins/vuetify-mask.js";

import router from "./router";
import store from "./store";
import "./notifications";
import "vue-ckeditor2";
import { CreateElement, VNode } from "vue/types/umd";

// @ts-ignore
CKEDITOR.config.disableNativeSpellChecker = false;
// @ts-ignore
CKEDITOR.config.removePlugins = "liststyle,tableselection,tabletools,tableresize,contextmenu,scayt";

Vue.config.productionTip = false;

init();

setInterval(handleExpires, 1000 * 10); // check every 10 seconds

let warningVisible = false;
async function handleExpires(): Promise<void> {
  const {
    state: {
      session: { loggedIn },
    },
  } = store;
  if (!loggedIn) {
    return;
  }

  if (!isInWarning()) {
    return;
  }

  // If expired then log out
  if (isExpired()) {
    logout();
    return;
  }

  if (warningVisible) {
    return;
  }

  // If in warning window but not expired, show warning
  warningShow();
}

function isInWarning(): boolean {
  const {
    state: {
      session: { expires },
    },
  } = store;

  // Current time in seconds
  const now = Math.floor(Date.now() / 1000);

  const timeTillExpires = expires - now;

  // If time till expires is less than 2 minutes then warn
  return timeTillExpires < 60 * 10;
}

function isExpired(): boolean {
  const {
    state: {
      session: { expires },
    },
  } = store;
  const now = Math.floor(Date.now() / 1000);

  return now > expires;
}

function warningShow(): void {
  warningVisible = true;

  iziToast.question({
    timeout: false,
    close: false,
    overlay: true,
    displayMode: 1,
    id: "question",
    zindex: 999,
    title: "Hi!",
    message: "Your session is almost expired. Would you like to extend it?",
    position: "center",
    buttons: [["<button><b>YES</b></button>", clickYes, true], ["<button>NO</button>", clickNo, false]],
  });
}

async function clickYes(instance: any, toast: any) {
  await store.dispatch("session/refresh");
  instance.hide({ transitionOut: "fadeOut" }, toast, "button");
  warningVisible = false;
}

function clickNo(instance: any, toast: any) {
  instance.hide({ transitionOut: "fadeOut" }, toast, "button");
  warningVisible = false;
}

function logout(): void {
  iziToast.destroy();
  warningVisible = false;
  removeCookie(store.state.session.jwtName);
  store.commit("session/reset");
  location.href = "/login";
}

async function init(): Promise<void> {
  await store.dispatch("session/load");

  if (store.state.session.loggedIn) {
    await store.dispatch("featureFlag/load");
  }

  new Vue({
    router,
    store,
    vuetify,
    vuetifyMask,
    // @ts-ignore
    render: (h: CreateElement): VNode => h(App),
  }).$mount("#app");
}
